export class PhoneMask {

    static codes = [
        "30",
        "357",
        "355",
        "44",
        "39",
        "7",
        "31",
        "1",
        "359",
        "90",
        "49",
        "40",
        "33",
        "381",
        "34",
        "41",
        "972",
        "48",
        "46",
        "86",
        "61",
        "961",
        "963",
        "32",
        "43",
        "353",
        "45",
        "81",
        "850",
        "54",
        "385",
        "36",
        "420",
        "358",
        "47",
        "55",
        "20",
        "389",
        "351",
        "380",
    ];

    static getMatch(input: any) {
        if (input == null)
            return null;
        input = input.toString();
        if (input.trim() == "")
            return null;
        for (var i = 0; i < PhoneMask.codes.length; i++) {
            var current = PhoneMask.codes[i];
            if (input.indexOf("00" + current) == 0 || input.indexOf("+" + current) == 0) {
                return current;
            }
        }
        return null;
    }

}